import { useEffect } from "react";
import { Link } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

const relatedArticles = [
  {
    tag: "Vendas",
    title: "Como Gleice Lyra Multiplica Resultados em Vendas",
    desc: "A metodologia exclusiva da Clientizah está transformando a performance de times comerciais em todo o Brasil.",
    image: "https://readdy.ai/api/search-image?query=professional%20business%20woman%20confident%20presenter%20speaking%20corporate%20meeting%20modern%20office%20warm%20tones%20elegant%20style%20natural%20light%20minimalist&width=600&height=380&seq=rel-editorial2&orientation=landscape",
    date: "18 Fev 2025",
  },
  {
    tag: "Experiência do Cliente",
    title: "O Segredo por Trás da Fidelização no Varejo",
    desc: "Clientizah e Gleice Lyra ensinam como encantar clientes e transformar compradores em fãs da sua marca.",
    image: "https://readdy.ai/api/search-image?query=happy%20customer%20shopping%20experience%20luxury%20store%20smiling%20warm%20welcoming%20atmosphere%20premium%20service%20elegant%20interior%20golden%20hour&width=600&height=380&seq=rel-editorial3&orientation=landscape",
    date: "02 Mar 2025",
  },
  {
    tag: "Gestão",
    title: "Planilhas e Metas: Como Organizar sua Equipe de Vendas",
    desc: "Ferramentas práticas e gratuitas que qualquer lojista pode implementar ainda esta semana.",
    image: "https://readdy.ai/api/search-image?query=business%20planning%20charts%20analytics%20team%20meeting%20modern%20office%20desk%20laptop%20notebook%20pen%20minimalist%20warm%20neutral%20tones%20professional&width=600&height=380&seq=rel-editorial4&orientation=landscape",
    date: "10 Mar 2025",
  },
];

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "Clientizah fala sobre Experiência do Cliente no Varejo atual",
  description:
    "Gleice Lyra e a Clientizah debatem experiência do cliente no varejo atual. Mais de 3.000 profissionais treinados com o Método CAT e 40% de aumento médio em vendas.",
  author: {
    "@type": "Person",
    name: "Gleice Lyra",
    jobTitle: "Fundadora da Clientizah",
  },
  publisher: {
    "@type": "Organization",
    name: "Clientizah",
    logo: {
      "@type": "ImageObject",
      url: "https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/dcebc87a-58a3-4ffb-968a-f62b795ba830_Slide1.jpg?v=bc79b70c22265c0c2e700194fd5ef66f",
    },
  },
  datePublished: "2025-10-08",
  dateModified: "2025-10-08",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": `${siteUrl}/materia`,
  },
  image:
    "https://readdy.ai/api/search-image?query=elegant%20modern%20retail%20store%20interior%20wide%20shot%20warm%20golden%20hour%20lighting%20luxury%20boutique%20atmosphere%20sophisticated%20minimalist%20display%20high%20end%20fashion%20store%20beautiful%20ambiance%20editorial%20photography&width=1600&height=900&seq=materia-hero-01&orientation=landscape",
  keywords: "Clientizah, Gleice Lyra, varejo brasileiro, Método CAT, treinamento vendas",
};

export default function Materia() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="relative min-h-screen bg-white">
      <title>Clientizah fala sobre Experiência do Cliente no Varejo | Na Mídia</title>
      <meta name="description" content="Gleice Lyra e Pierre Berenstein (presidente do Grupo Bold, dono do Outback) debatem CX no varejo e hospitalidade. Método CAT, Clientizah e mais de 3.000 profissionais treinados." />
      <meta name="keywords" content="experiência do cliente, CX varejo, Gleice Lyra, Clientizah, Pierre Berenstein, Outback, Método CAT, varejo brasileiro" />
      <link rel="canonical" href={`${siteUrl}/materia`} />
      <JsonLd data={jsonLd} />
      <Navbar />

      {/* Hero do artigo */}
      <div className="relative w-full h-[70vh] min-h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20modern%20retail%20store%20interior%20wide%20shot%20warm%20golden%20hour%20lighting%20luxury%20boutique%20atmosphere%20sophisticated%20minimalist%20display%20high%20end%20fashion%20store%20beautiful%20ambiance%20editorial%20photography&width=1600&height=900&seq=materia-hero-01&orientation=landscape"
          alt="Clientizah fala sobre Experiência do Cliente no Varejo atual"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/20" />
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-16 px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <span className="inline-block text-xs tracking-[0.3em] uppercase text-white/70 bg-white/10 border border-white/25 px-4 py-1.5 mb-5 rounded-sm">
              Experiência do Cliente
            </span>
            <h1 className="text-4xl md:text-6xl font-light text-white leading-tight mb-6 tracking-tight">
              Clientizah fala sobre Experiência<br />do Cliente no Varejo atual
            </h1>
            <div className="flex items-center justify-center gap-6 text-white/60 text-xs tracking-wide">
              <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-user-line"></i>
                </span>
                Gleice Lyra
              </span>
              <span className="w-1 h-1 bg-white/30 rounded-full"></span>
              <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-calendar-line"></i>
                </span>
                08 de Outubro, 2025
              </span>
              <span className="w-1 h-1 bg-white/30 rounded-full"></span>
              <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                8 min de leitura
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="px-6 md:px-16 py-5 border-b border-gray-100">
        <div className="max-w-4xl mx-auto flex items-center gap-2 text-xs text-gray-400 tracking-wide">
          <Link to="/" className="hover:text-black transition">Home</Link>
          <i className="ri-arrow-right-s-line text-gray-300"></i>
          <span className="text-gray-400">Na Mídia</span>
          <i className="ri-arrow-right-s-line text-gray-300"></i>
          <span className="text-black">Clientizah fala sobre Experiência do Cliente no Varejo atual</span>
        </div>
      </div>

      {/* Corpo do artigo */}
      <main className="px-6 md:px-16 py-16">
        <div className="max-w-4xl mx-auto">

          {/* Lead */}
          <p className="text-xl text-gray-700 leading-relaxed font-light mb-12 border-l-2 border-[#c4a882] pl-6">
            Gleice Lyra, fundadora da Clientizah, sentou com Pierre Berenstein — presidente do Grupo Bold Hospitality Company,
            dono das marcas Outback, Abbraccio e Aussie — para um papo direto e revelador sobre o estado atual da Experiência
            do Cliente no varejo e na hospitalidade brasileira.
          </p>

          {/* Bloco de stats */}
          <div className="grid grid-cols-3 gap-px bg-gray-100 mb-14 rounded-sm overflow-hidden">
            {[
              { value: "+3.000", label: "Profissionais Treinados" },
              { value: "3 marcas", label: "Bold Hospitality Company" },
              { value: "CX", label: "no centro da estratégia" },
            ].map((s) => (
              <div key={s.label} className="bg-white py-7 text-center">
                <p className="text-3xl font-light text-black tracking-tight mb-1">{s.value}</p>
                <p className="text-[11px] tracking-widest uppercase text-gray-400">{s.label}</p>
              </div>
            ))}
          </div>

          {/* Seção 1 */}
          <h2 className="text-2xl font-light tracking-tight text-black mb-5">
            Quando varejo e hospitalidade se encontram para falar de gente
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            O encontro entre Gleice Lyra e Pierre Berenstein não poderia ter sido mais revelador. De um lado,
            a fundadora da Clientizah e criadora do <strong>Método CAT</strong>, com 28 anos de experiência no chão de loja.
            Do outro, o presidente do <strong>Grupo Bold Hospitality Company</strong> — responsável pelas operações do Outback,
            Abbraccio e Aussie no Brasil —, um dos maiores grupos de alimentação e hospitalidade do país.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-10">
            O tema central: como a Experiência do Cliente (CX) é hoje o principal diferencial competitivo de qualquer
            negócio — seja uma loja de roupas no interior ou uma rede internacional de restaurantes com centenas de
            unidades espalhadas pelo Brasil.
          </p>

          {/* Imagem central */}
          <div className="my-12 w-full overflow-hidden rounded-sm bg-[#f5f2ef]">
            <img
              src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/05b0d337-af09-435b-898c-50532b86507a_compressed_IMG_7472.webp"
              alt="Gleice Lyra em palestra sobre varejo"
              className="w-full h-auto object-contain"
            />
          </div>
          <p className="text-[11px] text-gray-400 text-center tracking-wide mb-12 -mt-6">
            Gleice Lyra e Pierre Berenstein (presidente do Grupo Bold Hospitality Company) — papo sobre CX, outubro de 2025
          </p>

          {/* Seção 2 */}
          <h2 className="text-2xl font-light tracking-tight text-black mb-5">
            O que Pierre Berenstein pensa sobre CX no setor de hospitalidade
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Para Pierre, a experiência do cliente deixou de ser um departamento e passou a ser a própria cultura da empresa.
            &ldquo;A gente não vende comida. A gente vende momentos. O produto é o pretexto — o que o cliente
            leva pra casa é a sensação de ter sido bem tratado&rdquo;, afirmou o presidente do grupo responsável
            por mais de 100 unidades do Outback no Brasil.
          </p>

          {/* Citação destacada */}
          <blockquote className="my-10 px-8 py-7 bg-[#f5f2ef] border-l-4 border-[#c4a882]">
            <p className="text-lg font-light text-black leading-relaxed italic mb-3">
              &ldquo;A experiência do cliente não começa quando ele entra pela porta. Começa no momento em que ele decide ir até você.&rdquo;
            </p>
            <cite className="text-xs tracking-widest uppercase text-gray-500 not-italic">— Pierre Berenstein, presidente do Grupo Bold Hospitality Company</cite>
          </blockquote>

          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Gleice complementou com sua visão do varejo: &ldquo;O vendedor é
            o CX em pessoa. Não tem app, chatbot ou sistema que substitua um vendedor que realmente enxerga o cliente&rdquo;,
            disse ela. &ldquo;E isso se treina. Isso se aprende.&rdquo;
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-10">
            Os dois concordaram em um ponto central: empresas que investem em treinamento de equipe e cultura de
            atendimento são as que constroem bases sólidas de fidelização — especialmente em um cenário onde o
            consumidor está cada vez mais exigente e menos paciente com experiências mediocres.
          </p>

          {/* Lista de destaques */}
          <div className="mb-12 bg-white border border-gray-100 rounded-sm p-8">
            <h3 className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-6">Os principais pontos do papo sobre CX</h3>
            <ul className="space-y-4">
              {[
                "CX não é um departamento — é uma cultura que permeia todos os setores da empresa",
                "A experiência do cliente começa antes mesmo de ele entrar na loja ou no restaurante",
                "Equipes bem treinadas são o maior diferencial competitivo no varejo e na hospitalidade",
                "O vendedor e o garçom são a linha de frente do CX — e precisam ser tratados como tal",
                "Fidelização é consequência de consistência: fazer bem feito toda vez, sem exceções",
                "Tecnologia potencializa o atendimento, mas não substitui o calor humano",
                "Investir em treinamento é investir em receita — os números comprovam isso",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-[#c4a882] text-base"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Seção 3 */}
          <h2 className="text-2xl font-light tracking-tight text-black mb-5">
            O que une o varejo e a hospitalidade na visão de Gleice e Pierre
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Apesar de atuarem em segmentos diferentes, Gleice e Pierre chegaram à mesma conclusão: o cliente
            brasileiro está mais informado, mais conectado e muito menos tolerante com atendimento ruim.
            &ldquo;Hoje, uma experiência negativa vira post em segundos. Uma positiva, cria fãs para a vida toda&rdquo;,
            resumiu Pierre.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-10">
            Gleice trouxe dados do mercado varejista: mais de 3.000 profissionais treinados pelo Método CAT
            relatam em média <strong>40% de aumento em vendas</strong> no primeiro mês — e o principal motivo apontado
            por eles não é o produto ou o preço, mas a qualidade do atendimento. &ldquo;O cliente compra de quem
            ele gosta. Sempre foi assim. A gente só precisa lembrar disso todo dia&rdquo;, concluiu a fundadora da Clientizah.
          </p>

          {/* Dois depoimentos */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14">
            {[
              {
                name: "Ana Paula Ferreira",
                role: "Gerente de Loja — São Paulo, SP",
                text: "Depois do Método CAT, minha equipe bateu a meta pela primeira vez em 8 meses. A forma como a Gleice explica o comportamento do consumidor mudou completamente nossa abordagem.",
                initials: "AP",
                color: "bg-[#c4a882]",
              },
              {
                name: "Carla Mendonça",
                role: "Empreendedora — Belo Horizonte, MG",
                text: "Eu vendia bem, mas não sabia o porquê. Com o CAT entendi toda a lógica e consegui replicar o que funcionava. Faturei 40% a mais no mês seguinte ao curso.",
                initials: "CM",
                color: "bg-[#8c9e8a]",
              },
            ].map((t) => (
              <div key={t.name} className="bg-[#faf9f7] p-7 rounded-sm">
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#c9a84c] text-xs"></i>
                  ))}
                </div>
                <p className="text-gray-700 text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full ${t.color} flex-shrink-0`}>
                    <span className="text-white text-[10px] font-semibold">{t.initials}</span>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-black">{t.name}</p>
                    <p className="text-[10px] text-gray-400">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Seção 4 — CX e Tecnologia */}
          <h2 className="text-2xl font-light tracking-tight text-black mb-5">
            CX e tecnologia: como usar sem perder o fator humano
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Um dos temas mais quentes da conversa foi a relação entre tecnologia e experiência do cliente.
            Pierre compartilhou como o Grupo Bold usa dados e sistemas para antecipar necessidades, personalizar
            ofertas e medir satisfação em tempo real — sem abrir mão do acolhimento que é a marca registrada
            do Outback e de suas outras redes.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-10">
            Gleice trouxe a perspectiva do varejo: &ldquo;A IA é uma aliada incrível para quem já sabe atender bem.
            Ela automatiza o operacional e libera a equipe para fazer o que não tem substituto: criar conexão
            humana genuína com o cliente&rdquo;. Para ela, o vendedor do futuro não é o que conhece mais produto
            — é o que sabe usar tecnologia sem perder a essência do relacionamento.
          </p>

          {/* Imagem 2 */}
          <div className="my-10 w-full h-72 overflow-hidden rounded-sm">
            <img
              src="https://static.readdy.ai/image/53e8cd469a0b555bf3479b8b73e4877d/551d86298105669e33c30188f9918945.png"
              alt="Gleice Lyra apresentando Códigos do Luxo em palestra"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* CTA box */}
          <div className="mt-14 bg-black text-white p-10 md:p-14 text-center rounded-sm">
            <p className="text-xs tracking-[0.3em] uppercase text-white/50 mb-3">Método CAT — Clientizah</p>
            <h3 className="text-3xl md:text-4xl font-light leading-snug mb-4">
              Pronto para transformar seus<br />resultados no varejo?
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-lg mx-auto mb-8">
              Acesse o curso completo com certificado, bônus exclusivos e suporte da Gleice Lyra.
              100% online, no seu ritmo.
            </p>
            <Link
              to="/inscricao"
              className="inline-block whitespace-nowrap bg-[#c4a882] text-black text-xs tracking-widest uppercase font-semibold px-10 py-4 hover:bg-[#b8962e] transition-colors cursor-pointer rounded-sm"
            >
              Quero me inscrever agora
            </Link>
          </div>

        </div>
      </main>

      {/* Artigos relacionados */}
      <section className="py-20 px-6 md:px-16 bg-[#f5f2ef]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-2">Leia também</p>
            <h2 className="text-2xl font-light tracking-tight text-black">Mais da Clientizah</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {relatedArticles.map((art) => (
              <div key={art.title} className="group cursor-pointer bg-white overflow-hidden rounded-sm">
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={art.image}
                    alt={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-[10px] tracking-[0.2em] uppercase text-[#c4a882] font-medium">{art.tag}</span>
                    <span className="text-[10px] text-gray-400">{art.date}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-black leading-snug mb-2">{art.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed mb-4">{art.desc}</p>
                  <span className="text-[11px] tracking-widest uppercase border-b border-gray-300 pb-0.5 inline-block text-black group-hover:border-black transition">
                    Leia mais
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
